import { HttpStatusCode } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { Injectable, Inject } from '@angular/core';
import { LOGGER } from '@modules/core';
import { ApiError } from '@modules/ticket-fares-store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggingService } from '@nx-ng/types';
import { isApiError } from '@nx-ng/util';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { DirectDebitActions } from '../../actions';
import { DDAccountVerifyResponse } from '../../client/src';
import { CheckoutService } from '../../services';

@Injectable()
export class DirectDebitEffects {
  veriyDirectDebit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DirectDebitActions.checkoutAPI_verifyDirectDebitDetails),
      switchMap(
        (
          action: {
            sortCode: string;
            accountNumber: string;
          } & Action
        ) => {
          const { sortCode, accountNumber } = action;
          return this.checkoutService
            .validateDirectDebit(accountNumber, sortCode)
            .pipe(
              switchMap((response: DDAccountVerifyResponse) => {
                return of(
                  DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsSuccess(
                    {
                      response,
                    }
                  )
                );
              }),
              catchError((error) => {
                const apiError: ApiError | string =
                  error?.response?.parsedBody || error;

                if (
                  isApiError(error) &&
                  error.code === HttpStatusCode.NotFound
                ) {
                  return of(
                    DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsNotFound()
                  );
                }

                this.logger.logApiError(
                  {
                    apiError,
                  },
                  error
                );

                return of(
                  DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsFailure(
                    {
                      error: apiError,
                      retryAction: action,
                    }
                  )
                );
              })
            );
        }
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly checkoutService: CheckoutService,
    @Inject(LOGGER) private logger: LoggingService
  ) {}
}
